import React, { createContext, useState } from "react";
import examQuestions from "../data/examQuestions";
import { shuffle } from "../utils/shuffle";
export const ExamContext = createContext();

export const ExamProvider = ({ children }) => {
  const [questions, setQuestions] = useState(
    shuffle(examQuestions).slice(0, 20)
  );
  const [results, setResults] = useState(null);

  return (
    <ExamContext.Provider value={{ questions, results, setResults }}>
      {children}
    </ExamContext.Provider>
  );
};
